<template>
  <div>
    <el-table :data="list" border size="small" class="mt-10 table-fixed">
      <el-table-column
        align="center"
        label="库存基地"
        prop="base.name"
      ></el-table-column>
      <el-table-column
        align="center"
        label="库存数量"
        prop="count"
        min-width="200"
      >
        <template slot-scope="scope">
          <el-link
            class="font-12"
            type="primary"
            :underline="false"
            @click="handleShowDetail(scope.row.base_id)"
            >{{ scope.row.count }}</el-link
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { itemTemplateInventoryStatistic } from '@/service/getData'

export default {
  props: {
    itemTemplateId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await itemTemplateInventoryStatistic({
        id: this.itemTemplateId,
      })
      if (res.code == 0) {
        this.list = res.data.list
      }
    },

    handleShowDetail(baseid) {
      let filter = {
        item_template_id: this.itemTemplateId,
        base_id: baseid,
        page: 1,
        size: 10,
      }
      this.$router.push(`/instrument_items?filter=${JSON.stringify(filter)}`)
    },
  },
}
</script>